var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCategorySweets(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 151,
    viewBox: "0 0 151 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_343_7308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.4752 111.887C56.8787 111.887 39.8123 109.267 26.4443 104.898C28.3676 112.137 31.9808 117.611 36.4361 119.362C46.4914 123.317 60.2717 125.755 75.4752 125.755C90.6787 125.755 104.459 123.317 114.514 119.362C118.97 117.61 122.583 112.137 124.506 104.898C111.138 109.267 94.0717 111.887 75.4752 111.887Z",
    fill: "url(#paint0_linear_343_7308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.476 91.3598C150.476 128.105 0.475586 128.105 0.475586 91.3598C0.475586 54.6151 150.476 54.6151 150.476 91.3598Z",
    fill: "url(#paint1_linear_343_7308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.181 88.6651C140.181 114.862 10.7695 114.862 10.7695 88.6651C10.7695 62.4681 140.181 62.4681 140.181 88.6651Z",
    fill: "url(#paint2_linear_343_7308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.475 91.3598C150.475 61.3027 50.1115 55.8336 13.5768 74.9495C13.5586 81.5857 13.5389 88.7604 13.536 89.8736L13.5357 89.9701C13.5292 92.3601 14.6066 94.4163 16.3407 95.6913L35.8045 115.155C80.1495 124.451 150.475 116.52 150.475 91.3598Z",
    fill: "url(#paint3_linear_343_7308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2232 118.093L38.6741 100.544C37.8797 99.6171 36.7029 99.028 35.3867 99.028C32.9941 99.028 31.0547 100.967 31.0547 103.36C31.0547 103.752 31.29 104.078 31.6785 104.341L43.9659 116.629C47.9273 117.239 52.032 117.726 56.2232 118.093Z",
    fill: "url(#paint4_linear_343_7308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5234 118.861L58.0937 96.4312C57.169 95.3201 55.689 94.5604 53.3923 94.4815C53.1361 94.4727 52.8799 94.4986 52.6311 94.5609C50.6776 95.0507 41.407 97.6442 41.112 102.84C41.0573 103.805 41.497 104.57 42.264 105.177L55.0761 117.989C63.349 118.759 71.9799 119.049 80.5234 118.861Z",
    fill: "url(#paint5_linear_343_7308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.399 69.8053L137.414 64.5494C137.489 37.0723 123.442 31.2541 117.772 30.0253C116.478 29.7432 115.102 29.7876 113.754 30.1529L19.3943 55.7953C16.0652 56.6994 13.6193 59.8053 13.6102 63.1414C13.6102 63.1414 13.5428 87.7323 13.5369 89.8741L13.5367 89.9705C13.5261 93.8332 16.3414 96.8294 20.1967 97.0526L127.996 103.313C132.87 103.594 137.318 99.4053 137.332 94.5194C137.331 94.5197 137.392 72.3088 137.399 69.8053Z",
    fill: "url(#paint6_linear_343_7308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.773 30.0232C116.478 29.7423 115.1 29.7882 113.754 30.1541L19.3939 55.7946C18.2065 56.1173 17.135 56.7235 16.2427 57.5164L137.413 64.6514L137.413 64.5496C137.489 37.0714 123.442 31.2526 117.773 30.0232Z",
    fill: "url(#paint7_linear_343_7308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8832 61.441L16.2432 57.516C17.1343 56.7225 18.207 56.1169 19.3949 55.7936L70.0749 42.0225C69.4617 43.2175 69.1099 44.5533 69.1064 45.9369C69.0996 48.3736 70.1679 50.4336 71.8485 51.6889L82.8832 61.441Z",
    fill: "url(#paint8_linear_343_7308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.415 64.5504L137.415 64.6513L123.912 63.8566L123.269 63.8189L123.181 63.8118L82.8832 61.4407L71.8485 51.6886C70.1679 50.4333 69.0997 48.3733 69.1065 45.9366C69.1103 44.553 69.4618 43.2171 70.075 42.0221L92.5047 35.9274L113.755 30.1524C115.1 29.7877 116.478 29.7416 117.774 30.023C123.441 31.2516 137.49 37.0701 137.415 64.5504Z",
    fill: "url(#paint9_linear_343_7308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.465 88.6451L126.502 74.9301C126.509 72.6453 124.844 70.8733 122.565 70.7392L13.606 64.323C13.5924 69.2492 13.541 88.0145 13.536 89.8736L13.5357 89.9701C13.5342 90.473 13.5819 90.9609 13.6724 91.4303L117.129 97.4386C122.003 97.7198 126.451 93.5309 126.465 88.6451Z",
    fill: "url(#paint10_linear_343_7308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.47 86.3802L126.464 88.6449C126.459 90.5114 125.805 92.2779 124.727 93.7297L13.5415 87.2735L13.5618 79.8214L126.47 86.3802Z",
    fill: "url(#paint11_linear_343_7308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.501 74.9306L126.481 82.2435L13.5732 75.6876L13.5935 68.2385L126.499 74.7947C126.501 74.8379 126.501 74.8844 126.501 74.9306Z",
    fill: "url(#paint12_linear_343_7308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.604 28.0212C115.238 27.7277 113.781 27.7903 112.361 28.1759C110.97 28.5539 110.604 30.3971 111.799 31.0065C118.095 34.2206 126.109 42.035 127.177 61.0221C127.277 62.8003 128.624 64.1336 130.412 64.2389L132.826 64.3439C135.253 64.4495 137.428 62.2871 137.291 59.8798C135.856 34.7539 122.242 29.2318 116.604 28.0212Z",
    fill: "url(#paint13_linear_343_7308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9924 33.0871C76.5945 34.5613 77.4362 36.6554 76.8727 37.7645C76.3092 38.8736 74.5536 38.578 72.9518 37.1039C71.3501 35.6298 68.1489 31.3651 68.7121 30.2557C69.2757 29.1466 73.3904 31.613 74.9924 33.0871Z",
    fill: "url(#paint14_linear_343_7308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4428 32.8348C77.7969 35.5418 77.0516 37.8854 75.7784 38.0695C74.5051 38.2536 73.186 36.2086 72.8319 33.5015C72.4778 30.7945 72.7016 24.4645 73.9748 24.2804C75.2481 24.0965 77.0887 30.128 77.4428 32.8348Z",
    fill: "url(#paint15_linear_343_7308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5475 36.8022C91.0142 41.121 88.0563 44.9827 83.9407 45.4274C79.8251 45.8722 76.1104 42.7319 75.6437 38.413C75.1769 34.0942 78.1348 30.2324 82.2504 29.7877C86.366 29.3427 90.0807 32.4833 90.5475 36.8022Z",
    fill: "url(#paint16_linear_343_7308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2282 31.7513C85.3174 32.5766 84.5594 33.3354 83.535 33.4463C82.5106 33.5569 81.608 32.9778 81.5188 32.1522C81.4297 31.3269 82.1877 30.5681 83.2121 30.4572C84.2365 30.3463 85.1391 30.926 85.2282 31.7513Z",
    fill: "url(#paint17_linear_343_7308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2158 33.996C81.2585 34.3895 80.9888 34.7413 80.6138 34.7819C80.2388 34.8225 79.9003 34.5363 79.8579 34.1427C79.8155 33.7492 80.085 33.3975 80.46 33.3569C80.835 33.3163 81.1735 33.6024 81.2158 33.996Z",
    fill: "url(#paint18_linear_343_7308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4854 35.8836C84.528 36.2772 84.2583 36.6289 83.8833 36.6695C83.5083 36.7101 83.1698 36.4239 83.1274 36.0304C83.0851 35.6369 83.3545 35.2851 83.7295 35.2445C84.1042 35.2042 84.4427 35.4901 84.4854 35.8836Z",
    fill: "url(#paint19_linear_343_7308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8688 43.7386C83.3355 48.0575 80.3776 51.9192 76.262 52.3639C72.1464 52.8086 68.4317 49.6683 67.965 45.3495C67.4982 41.0307 70.4561 37.1689 74.5717 36.7242C78.6873 36.2795 82.402 39.4198 82.8688 43.7386Z",
    fill: "url(#paint20_linear_343_7308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5495 38.6878C77.6387 39.5131 76.8807 40.2719 75.8563 40.3828C74.8319 40.4934 73.9292 39.9142 73.8401 39.0887C73.751 38.2631 74.509 37.5045 75.5334 37.3937C76.5575 37.2831 77.4601 37.8625 77.5495 38.6878Z",
    fill: "url(#paint21_linear_343_7308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5371 40.9321C73.5798 41.3257 73.3101 41.6774 72.9351 41.718C72.5601 41.7586 72.2215 41.4724 72.1792 41.0789C72.1368 40.6854 72.4062 40.3336 72.7812 40.293C73.1562 40.2524 73.4948 40.5386 73.5371 40.9321Z",
    fill: "url(#paint22_linear_343_7308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8067 42.8201C76.8493 43.2136 76.5796 43.5654 76.2046 43.606C75.8296 43.6465 75.4911 43.3604 75.4487 42.9668C75.4064 42.5733 75.6758 42.2215 76.0508 42.181C76.4258 42.1404 76.764 42.4265 76.8067 42.8201Z",
    fill: "url(#paint23_linear_343_7308)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M18.7786 73.6997C19.615 73.6997 20.293 73.0217 20.293 72.1853C20.293 71.3489 19.615 70.6709 18.7786 70.6709C17.9422 70.6709 17.2642 71.3489 17.2642 72.1853C17.2642 73.0217 17.9422 73.6997 18.7786 73.6997Z",
    fill: "url(#paint24_linear_343_7308)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M17.2581 77.9565C17.9184 77.9565 18.4537 77.4212 18.4537 76.7609C18.4537 76.1006 17.9184 75.5653 17.2581 75.5653C16.5978 75.5653 16.0625 76.1006 16.0625 76.7609C16.0625 77.4212 16.5978 77.9565 17.2581 77.9565Z",
    fill: "url(#paint25_linear_343_7308)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M22.5319 76.89C22.93 76.89 23.2528 76.5673 23.2528 76.1691C23.2528 75.771 22.93 75.4482 22.5319 75.4482C22.1338 75.4482 21.811 75.771 21.811 76.1691C21.811 76.5673 22.1338 76.89 22.5319 76.89Z",
    fill: "url(#paint26_linear_343_7308)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M26.7632 72.013C27.3812 72.013 27.8823 71.512 27.8823 70.8939C27.8823 70.2758 27.3812 69.7748 26.7632 69.7748C26.1451 69.7748 25.644 70.2758 25.644 70.8939C25.644 71.512 26.1451 72.013 26.7632 72.013Z",
    fill: "url(#paint27_linear_343_7308)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M23.4944 73.1942C23.9823 73.1942 24.3779 72.7986 24.3779 72.3106C24.3779 71.8227 23.9823 71.4271 23.4944 71.4271C23.0064 71.4271 22.6108 71.8227 22.6108 72.3106C22.6108 72.7986 23.0064 73.1942 23.4944 73.1942Z",
    fill: "url(#paint28_linear_343_7308)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M26.4189 75.4565C26.713 75.4565 26.9515 75.218 26.9515 74.9239C26.9515 74.6297 26.713 74.3912 26.4189 74.3912C26.1247 74.3912 25.8862 74.6297 25.8862 74.9239C25.8862 75.218 26.1247 75.4565 26.4189 75.4565Z",
    fill: "url(#paint29_linear_343_7308)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M120.554 86.8587C121.39 86.8587 122.068 86.1806 122.068 85.3442C122.068 84.5079 121.39 83.8298 120.554 83.8298C119.718 83.8298 119.04 84.5079 119.04 85.3442C119.04 86.1806 119.718 86.8587 120.554 86.8587Z",
    fill: "url(#paint30_linear_343_7308)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M120.954 81.735C121.614 81.735 122.149 81.1998 122.149 80.5395C122.149 79.8792 121.614 79.3439 120.954 79.3439C120.294 79.3439 119.758 79.8792 119.758 80.5395C119.758 81.1998 120.294 81.735 120.954 81.735Z",
    fill: "url(#paint31_linear_343_7308)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M115.967 83.0774C116.366 83.0774 116.688 82.7546 116.688 82.3565C116.688 81.9584 116.366 81.6356 115.967 81.6356C115.569 81.6356 115.247 81.9584 115.247 82.3565C115.247 82.7546 115.569 83.0774 115.967 83.0774Z",
    fill: "url(#paint32_linear_343_7308)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M113.097 89.5987C113.715 89.5987 114.216 89.0977 114.216 88.4796C114.216 87.8615 113.715 87.3605 113.097 87.3605C112.479 87.3605 111.978 87.8615 111.978 88.4796C111.978 89.0977 112.479 89.5987 113.097 89.5987Z",
    fill: "url(#paint33_linear_343_7308)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M115.941 87.2163C116.429 87.2163 116.824 86.8207 116.824 86.3327C116.824 85.8448 116.429 85.4492 115.941 85.4492C115.453 85.4492 115.057 85.8448 115.057 86.3327C115.057 86.8207 115.453 87.2163 115.941 87.2163Z",
    fill: "url(#paint34_linear_343_7308)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M112.483 85.0145C112.777 85.0145 113.016 84.776 113.016 84.4819C113.016 84.1877 112.777 83.9492 112.483 83.9492C112.189 83.9492 111.95 84.1877 111.95 84.4819C111.95 84.776 112.189 85.0145 112.483 85.0145Z",
    fill: "url(#paint35_linear_343_7308)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M45.563 86.483C46.181 86.483 46.6821 85.9819 46.6821 85.3639C46.6821 84.7458 46.181 84.2448 45.563 84.2448C44.9449 84.2448 44.4438 84.7458 44.4438 85.3639C44.4438 85.9819 44.9449 86.483 45.563 86.483Z",
    fill: "url(#paint36_linear_343_7308)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M42.2942 87.6645C42.7821 87.6645 43.1777 87.269 43.1777 86.781C43.1777 86.293 42.7821 85.8975 42.2942 85.8975C41.8062 85.8975 41.4106 86.293 41.4106 86.781C41.4106 87.269 41.8062 87.6645 42.2942 87.6645Z",
    fill: "url(#paint37_linear_343_7308)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M45.2187 89.9265C45.5129 89.9265 45.7513 89.688 45.7513 89.3939C45.7513 89.0997 45.5129 88.8612 45.2187 88.8612C44.9245 88.8612 44.686 89.0997 44.686 89.3939C44.686 89.688 44.9245 89.9265 45.2187 89.9265Z",
    fill: "url(#paint38_linear_343_7308)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M53.3923 94.4819C53.1362 94.4731 52.88 94.499 52.6312 94.5613C50.6776 95.051 41.407 97.6445 41.112 102.84C40.9282 106.076 46.2741 107.077 51.0456 107.328C55.4029 107.558 59.1626 105.235 59.4179 102.163C59.7067 98.6843 58.8441 94.6687 53.3923 94.4819Z",
    fill: "url(#paint39_linear_343_7308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3923 94.4819C53.1362 94.4731 52.88 94.499 52.6312 94.5613C50.6776 95.051 41.407 97.6446 41.112 102.84C40.9282 106.076 46.2741 107.077 51.0456 107.328C55.4026 107.558 58.8441 94.6687 53.3923 94.4819Z",
    fill: "url(#paint40_linear_343_7308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7188 103.36C39.7188 105.753 31.0547 105.753 31.0547 103.36C31.0547 100.967 32.9944 99.0281 35.3867 99.0281C37.7791 99.0281 39.7188 100.967 39.7188 103.36Z",
    fill: "url(#paint41_linear_343_7308)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_343_7308",
    x1: 75.912,
    y1: 112.107,
    x2: 76.7023,
    y2: 125.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFDCFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_343_7308",
    x1: 69.4473,
    y1: 68.6077,
    x2: 83.5838,
    y2: 121.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFDCFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_343_7308",
    x1: 82.451,
    y1: 122.02,
    x2: 58.1875,
    y2: 5.99688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#E9D6F7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#C5B5DE",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#AA9BCB",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688BD",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8A7DB5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_343_7308",
    x1: 89.1886,
    y1: 110.882,
    x2: 48.0121,
    y2: -7.64785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#E9D6F7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#C5B5DE",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#AA9BCB",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688BD",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8A7DB5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_343_7308",
    x1: 48.3197,
    y1: 115.603,
    x2: 4.75998,
    y2: 72.0435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#E9D6F7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#C5B5DE",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#AA9BCB",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688BD",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8A7DB5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_343_7308",
    x1: 62.6264,
    y1: 113.686,
    x2: 34.3911,
    y2: 77.5098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#E9D6F7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#C5B5DE",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#AA9BCB",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688BD",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8A7DB5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_343_7308",
    x1: 66.3499,
    y1: 53.1499,
    x2: 113.272,
    y2: 135.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_343_7308",
    x1: 73.0119,
    y1: 45.6504,
    x2: 91.6737,
    y2: 84.6148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_343_7308",
    x1: 43.4976,
    y1: 44.0924,
    x2: 57.5807,
    y2: 73.4969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_343_7308",
    x1: 111.895,
    y1: 53.9226,
    x2: 72.4516,
    y2: 18.8487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2458,
    stopColor: "#F12817",
    stopOpacity: 0.246
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.608,
    stopColor: "#DD2820",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_343_7308",
    x1: 65.257,
    y1: 44.9685,
    x2: 74.9242,
    y2: 86.6706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA68E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3527,
    stopColor: "#FAA38F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.651,
    stopColor: "#FC9893"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9287,
    stopColor: "#FE879A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF819C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_343_7308",
    x1: 66.2276,
    y1: 72.3701,
    x2: 79.6494,
    y2: 109.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57C52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1339,
    stopColor: "#A26C4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5155,
    stopColor: "#994336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8174,
    stopColor: "#942A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#922125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_343_7308",
    x1: 69.0201,
    y1: 71.3718,
    x2: 82.4416,
    y2: 108.916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57C52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1339,
    stopColor: "#A26C4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5155,
    stopColor: "#994336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8174,
    stopColor: "#942A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#922125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_343_7308",
    x1: 121.681,
    y1: 34.7614,
    x2: 134.942,
    y2: 62.4492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_343_7308",
    x1: 73.2026,
    y1: 33.2762,
    x2: 71.8594,
    y2: 35.9911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2269,
    stopColor: "#B0CE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#95AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_343_7308",
    x1: 75.7857,
    y1: 31.0206,
    x2: 72.1638,
    y2: 33.8785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2269,
    stopColor: "#B0CE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#95AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_343_7308",
    x1: 80.9267,
    y1: 35.8274,
    x2: 88.4619,
    y2: 41.8858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2243,
    stopColor: "#FE5B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5952,
    stopColor: "#FC4637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_343_7308",
    x1: 85.3464,
    y1: 35.265,
    x2: 81.0926,
    y2: 28.0851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2243,
    stopColor: "#FE5B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5952,
    stopColor: "#FC4637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_343_7308",
    x1: 81.4211,
    y1: 35.5436,
    x2: 79.4961,
    y2: 32.2942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2243,
    stopColor: "#FE5B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5952,
    stopColor: "#FC4637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_343_7308",
    x1: 84.6909,
    y1: 37.4293,
    x2: 82.7659,
    y2: 34.1799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2243,
    stopColor: "#FE5B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5952,
    stopColor: "#FC4637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_343_7308",
    x1: 73.2531,
    y1: 42.7671,
    x2: 80.7882,
    y2: 48.8256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2243,
    stopColor: "#FE5B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5952,
    stopColor: "#FC4637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_343_7308",
    x1: 77.6724,
    y1: 42.2047,
    x2: 73.4187,
    y2: 35.0245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2243,
    stopColor: "#FE5B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5952,
    stopColor: "#FC4637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_343_7308",
    x1: 73.7474,
    y1: 42.483,
    x2: 71.8222,
    y2: 39.2339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2243,
    stopColor: "#FE5B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5952,
    stopColor: "#FC4637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_343_7308",
    x1: 77.0173,
    y1: 44.369,
    x2: 75.0923,
    y2: 41.1196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2243,
    stopColor: "#FE5B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5952,
    stopColor: "#FC4637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_343_7308",
    x1: 20.1936,
    y1: 74.0016,
    x2: 14.707,
    y2: 69.3852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42210B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_343_7308",
    x1: 18.2992,
    y1: 78.265,
    x2: 13.9679,
    y2: 74.6204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42210B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_343_7308",
    x1: 23.0213,
    y1: 77.2096,
    x2: 20.4101,
    y2: 75.0123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42210B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_343_7308",
    x1: 26.8179,
    y1: 73.0006,
    x2: 26.6549,
    y2: 67.7037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42210B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_343_7308",
    x1: 23.5371,
    y1: 74.0596,
    x2: 23.4082,
    y2: 69.8781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42210B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_343_7308",
    x1: 26.4465,
    y1: 76.1395,
    x2: 26.3687,
    y2: 73.6185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42210B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_343_7308",
    x1: 118.102,
    y1: 84.3496,
    x2: 124.523,
    y2: 87.5409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42210B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_343_7308",
    x1: 118.936,
    y1: 79.7597,
    x2: 124.005,
    y2: 82.2792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42210B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_343_7308",
    x1: 114.597,
    y1: 81.8999,
    x2: 117.653,
    y2: 83.4186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42210B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_343_7308",
    x1: 112.8,
    y1: 86.8869,
    x2: 114.204,
    y2: 91.9939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42210B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_343_7308",
    x1: 115.738,
    y1: 85.0861,
    x2: 116.847,
    y2: 89.1178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42210B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_343_7308",
    x1: 112.423,
    y1: 83.75,
    x2: 113.091,
    y2: 86.1806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42210B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_343_7308",
    x1: 45.6265,
    y1: 87.4759,
    x2: 45.4632,
    y2: 82.1788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42210B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_343_7308",
    x1: 42.3453,
    y1: 88.535,
    x2: 42.2166,
    y2: 84.3532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42210B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_343_7308",
    x1: 45.2548,
    y1: 90.6146,
    x2: 45.1773,
    y2: 88.0937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42210B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_343_7308",
    x1: 49.5206,
    y1: 99.0666,
    x2: 52.0764,
    y2: 106.967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA68E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3527,
    stopColor: "#FAA38F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.651,
    stopColor: "#FC9893"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9287,
    stopColor: "#FE879A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF819C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_343_7308",
    x1: 48.1714,
    y1: 99.7231,
    x2: 53.232,
    y2: 104.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA68E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3527,
    stopColor: "#FAA38F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.651,
    stopColor: "#FC9893"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9287,
    stopColor: "#FE879A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF819C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_343_7308",
    x1: 33.422,
    y1: 99.174,
    x2: 37.0985,
    y2: 106.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_343_7308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(0.475586 0.0158691)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCategorySweets);
export default __webpack_public_path__ + "static/media/icon-category-sweets.e919e1c9.svg";
export { ForwardRef as ReactComponent };